import type { IconData } from '@stacksjs/iconify-core'

export const temperature: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M10 15a5 5 0 1 1-8-4V3a3 3 0 1 1 6 0v8c1.214.912 2 2.364 2 4m-3.201-2.401l-.799-.6V3a1 1 0 1 0-2 0v8.999l-.799.6a3 3 0 1 0 3.598 0M5 17a2 2 0 1 1 0-4a2 2 0 0 1 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default temperature
